import React from "react";
import SpecialtyConsole from "./SpecialtyConsole";

const CALCULATORS = [
  {
    name: "Child-Pugh (cirrhosis)",
    endpoint: "child-pugh",
    fields: [
      { name: "bilirubin_mg_dl", label: "Bilirubin (mg/dL)",      placeholder: "e.g. 2.4" },
      { name: "albumin_g_dl",    label: "Albumin (g/dL)",         placeholder: "e.g. 3.0" },
      { name: "inr",             label: "INR",                    placeholder: "e.g. 1.5" },
      { name: "ascites",         label: "Ascites",                type: "select",
        options: [{value: "none", label: "None"}, {value: "mild", label: "Mild"}, {value: "moderate", label: "Moderate"}] },
      { name: "encephalopathy_grade", label: "Encephalopathy grade", hint: "0-4",
        placeholder: "0" },
    ],
    defaults: { bilirubin_mg_dl: 2.0, albumin_g_dl: 3.2, inr: 1.4,
                ascites: "none", encephalopathy_grade: 0 },
  },
  {
    name: "MELD-Na",
    endpoint: "meld",
    fields: [
      { name: "creatinine_mg_dl", label: "Creatinine (mg/dL)", placeholder: "e.g. 1.5" },
      { name: "bilirubin_mg_dl",  label: "Bilirubin (mg/dL)",  placeholder: "e.g. 3.0" },
      { name: "inr",              label: "INR",                placeholder: "e.g. 1.6" },
      { name: "sodium_meq_l",     label: "Sodium (mEq/L)",     placeholder: "e.g. 132" },
    ],
    defaults: { creatinine_mg_dl: 1.5, bilirubin_mg_dl: 2.5, inr: 1.5, sodium_meq_l: 133 },
  },
  {
    name: "Rockall (post-endoscopy)",
    endpoint: "rockall",
    fields: [
      { name: "age_pts",         label: "Age pts",         hint: "0-2" },
      { name: "shock_pts",       label: "Shock pts",       hint: "0-2" },
      { name: "comorbidity_pts", label: "Comorbidity pts", hint: "0-3" },
      { name: "diagnosis_pts",   label: "Diagnosis pts",   hint: "0-2" },
      { name: "stigmata_pts",    label: "Stigmata pts",    hint: "0-2" },
    ],
    defaults: { age_pts: 1, shock_pts: 0, comorbidity_pts: 0, diagnosis_pts: 1, stigmata_pts: 0 },
  },
  {
    name: "Glasgow-Blatchford (pre-endoscopy)",
    endpoint: "glasgow-blatchford",
    fields: [
      { name: "hb_g_dl",     label: "Hb (g/dL)",  placeholder: "e.g. 10.5" },
      { name: "bun_mg_dl",   label: "BUN (mg/dL)", placeholder: "e.g. 30" },
      { name: "sbp",         label: "SBP (mmHg)",  placeholder: "e.g. 95" },
      { name: "hr",          label: "HR",          placeholder: "e.g. 105" },
      { name: "melena",      label: "Melena", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "syncope",     label: "Syncope", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "hepatic",     label: "Hepatic disease", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "cardiac",     label: "Cardiac disease", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "sex",         label: "Sex", type: "select",
        options: [{value: "male", label: "Male"}, {value: "female", label: "Female"}] },
    ],
    defaults: { hb_g_dl: 11, bun_mg_dl: 20, sbp: 110, hr: 90,
                melena: false, syncope: false, hepatic: false, cardiac: false, sex: "male" },
  },
];

export default function Gastroenterology() {
  return <SpecialtyConsole
    specialtyId="gastroenterology"
    title="Gastroenterology"
    tagline="Liver, IBD, and GI care"
    accent="#F97316"
    calculators={CALCULATORS}
  />;
}
